<script>
import Loading from "@/components/Loading.vue";
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";
import {mapGetters} from "vuex";

export default {
  name: "MeetingsAnalytics",
  components: {AnalyticsDetailRow, Loading},
  computed: {
    ...mapGetters(["currentEvent"])
  },
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    view() {
      this.$router.push({
        name: "meetingAnalytics",
        params: {
          eventId: this.currentEvent.id,
        }});
    }
  }
}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true">
      <v-card-title>Meetings</v-card-title>
<!--      <div class="pb-4">
      <v-divider/>
      </div>-->
      <div class="px-4 pb-4">
        <AnalyticsDetailRow
            :icon="`group-discussion-meeting.${isPdf ? 'png' : 'svg'}`"
            :title="`${this.currentEvent.analyticsData.meetings} meetings created` " value="" :show-view-button="true" @onView="view"/>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

</style>